module.exports = __webpack_public_path__ + "static/media/bewise-logo-new.125629f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bewise-logo-new.png
// module id = 1632
// module chunks = 0